import { Image } from "@gui/components";
import * as styles from "./css/CurrentGunImage.module.css";
const CurrentGunImage = props => {
    return (<span class={styles.container}>
            <Image alt={props.gunName} src={props.gunImageSource} class={styles.image}/>
        </span>);
};
export default CurrentGunImage;
